<template>
  <div class="container-fluid fixed-bottom" ref="footer" id="footer">
    <div class="row border-top">
      <div class="col d-flex justify-content-around py-2 tabbar">
        <div class="text-center lh-1" :class="{ 'text-red': currentActive == 'home' }" @click.stop="patients">
          <!-- <icon width="30" height="30" name="home"></icon> -->
          <img src="/Icones_euros/icon_home_on.svg" width="35" height="35" alt="home" v-if="currentActive == 'home'" />
          <img src="/Icones_euros/icon_home_off.svg" width="35" height="35" alt="home" v-else />

          <div>Activités</div>
        </div>
        <div class="text-center lh-1" :class="{ 'text-red': currentActive == 'newpatient' }" @click.stop="newPatient">
          <div class="position-relative w-100">
            <div class="position-absolute" style="z-index: 2000; top: -120px; left: -40px;width:150px;" v-if="showNew">
              <div class="" style="display: block">
                <button class="btn btn-primary mb-3 w-100 d-flex align-items-center justify-content-center"
                  href="javascript:void(0);" @click="gotoNewPatient('hanche')">
                  <!-- <div class="mr-2">
                    <icon width="15" height="15" name="plus-circle"></icon>
                  </div> -->
                  <div>Hanche</div>
                </button>
                <button class="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                  href="javascript:void(0);" @click="gotoNewPatient('genou')">
                  <!-- <div class="mr-2">
                    <icon width="15" height="15" name="plus-circle"></icon>
                  </div> -->
                  <div>Genou</div>
                </button>
              </div>
            </div>
          </div>
          <!-- <icon width="30" height="30" name="plus-circle"></icon> -->
          <img src="/Icones_euros/icon_plus_on.svg" width="35" height="35" alt="add"
            v-if="currentActive == 'newpatient'" />
          <img src="/Icones_euros/icon_plus_off.svg" width="35" height="35" alt="add" v-else />
          <div>Plannification</div>
        </div>
        <div class="text-center lh-1" :class="{ 'text-red': currentActive == 'settings' }" @click.stop="settings">
          <!-- <icon width="30" height="30" name="cog"></icon> -->
          <img src="/Icones_euros/icon_pref_on.svg" width="35" height="35" alt="settings"
            v-if="currentActive == 'settings'" />
          <img src="/Icones_euros/icon_pref_off.svg" width="35" height="35" alt="settings" v-else />
          <div>Compte</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabbar",
  components: {},
  props: {
    titre: String,
    btnRetour: { type: String, default: "Liste" },
    pathRetour: String,
    currentActive: { type: String, default: "home" }
  },
  data() {
    return { showhelp: false, showNew: false };
  },
  async mounted() {},
  watch: {},
  computed: {},
  methods: {
    newPatient() {
      this.showNew = !this.showNew;
      // console.log("newPatient", this.$store.state.currentActivite);
      // this.$emit("changeActive", "newPatient");
      // if (this.$store.state.currentActivite == "hanche") this.$router.push("/chooseimage").catch(err => {});
      // if (this.$store.state.currentActivite == "genou") this.$router.push("/editgenou/0").catch(err => {});
    },
    gotoNewPatient(where) {
      this.$emit("changeActive", "newPatient");
      this.showNew = false;
      if (where == "hanche") this.$router.push("/chooseimage").catch(err => {});
      if (where == "genou") this.$router.push("/editgenou/0").catch(err => {});
    },
    patients() {
      this.$emit("changeActive", "patients");
      this.$router.push("/patients").catch(err => {});
    },
    settings() {
      this.$emit("changeActive", "settings");
      this.$router.push("/settings").catch(err => {});
    },
    help() {
      this.$emit("changeActive", "help");
      this.showhelp = true;
    }
  }
};
</script>
<style scoped lang="scss">
.color-disable {
  a {
    color: #96c2f0;
  }
}

#header {
  position: fixed;
  background-color: #fff;
  z-index: 100;
}
</style>
